const PERFORMANCE_PINS_STORAGE_KEY_PREFIX = "izanagi.performancePins";

/** 期間内に実行されず統計に出てこないときも何のクエリか分かるよう、文面も残す。 */
export interface PinnedQuery {
	queryId: string;
	query: string;
	/** タグの付いたクエリは、書き換えてクエリ ID が変わっても同じタグで推移を見る。 */
	tag: string | null;
}

export interface PerformancePins {
	queries: PinnedQuery[];
	/** `${method} ${route}` */
	endpoints: string[];
}

export const NO_PERFORMANCE_PINS: PerformancePins = { queries: [], endpoints: [] };

/** 共有端末やアカウント切り替えで、ほかの人のピン留めが混ざらないようユーザーごとに分ける。 */
function storageKey(userId: string): string {
	return `${PERFORMANCE_PINS_STORAGE_KEY_PREFIX}.${userId}`;
}

/** タグを持つ前に保存したピン留めは、タグなしとして読む。 */
function toPinnedQuery(value: unknown): PinnedQuery[] {
	if (typeof value !== "object" || value === null) return [];
	const { queryId, query, tag } = value as Record<string, unknown>;
	if (typeof queryId !== "string" || typeof query !== "string") return [];
	return [{ queryId, query, tag: typeof tag === "string" ? tag : null }];
}

/** 壊れた項目は読み飛ばす。 */
export function parsePerformancePins(raw: string): PerformancePins {
	const parsed: unknown = JSON.parse(raw);
	if (typeof parsed !== "object" || parsed === null) return NO_PERFORMANCE_PINS;
	const { queries, endpoints } = parsed as Record<string, unknown>;
	return {
		queries: Array.isArray(queries) ? queries.flatMap(toPinnedQuery) : [],
		endpoints: Array.isArray(endpoints)
			? endpoints.filter((e): e is string => typeof e === "string")
			: [],
	};
}

/** localStorage が使えない・保存値が壊れているときはピン留めなしで表示を続ける。 */
export function readPerformancePins(userId: string): PerformancePins {
	try {
		const raw = window.localStorage.getItem(storageKey(userId));
		return raw === null ? NO_PERFORMANCE_PINS : parsePerformancePins(raw);
	} catch (err: unknown) {
		console.error("パフォーマンスのピン留めを読めませんでした。", err);
		return NO_PERFORMANCE_PINS;
	}
}

/** 書けなくても、画面を開いている間はピン留めが効くので表示を続ける。 */
export function writePerformancePins(userId: string, pins: PerformancePins): void {
	try {
		window.localStorage.setItem(storageKey(userId), JSON.stringify(pins));
	} catch (err: unknown) {
		console.error("パフォーマンスのピン留めを保存できませんでした。", err);
	}
}
